import React from "react";
import {SegmentCategory} from "../../apis/requests/segments/types";
import {ColorMarker} from "../../ui/components";
import {SEGMENT_CATEGORY_INFO} from "./segment-form/constants";

type Props = {
  segmentCategory: SegmentCategory;
};

export const SegmentCategoryMarker = ({segmentCategory}: Props) => (
  <ColorMarker color={SEGMENT_CATEGORY_INFO[segmentCategory].color} />
);
